export const START_TOAST = 'START_TOAST';
export const CLEAR_TOAST = 'CLEAR_TOAST';

export function toast({
  action = '',
  message = '',
  onActionClick = () => {},
  error,
  autoHideDuration
}) {
  return {
    type: START_TOAST,
    action,
    message,
    onActionClick,
    error,
    autoHideDuration
  };
}

export function clearToast() {
  return {
    type: CLEAR_TOAST
  };
}



// WEBPACK FOOTER //
// ./js/actions/toast.js